import { createContext, type PropsWithChildren, useContext } from 'react';
import type { MarketingPreferences, MyOCData } from '@cx-web/domain-types/myoc';
import { type MyOCConfig } from '@cx-web/server-utils/types';

import { MyOCUserProvider } from '~/providers/myoc-user';

export type MyOCAuthProviderProps = {
  marketingPreferences?: MarketingPreferences;
  myocConfig: MyOCConfig;
  myocData: MyOCData;
};

export type MyOCAuthProviderData = {
  marketingPreferences?: MarketingPreferences;
  myocConfig: MyOCConfig;
  myocData: MyOCData;
};

export const MyOCAuthContext = createContext<MyOCAuthProviderData>(undefined as any as MyOCAuthProviderData);
MyOCAuthContext.displayName = 'MyOCAuthContext';

export const MyOCAuthProvider = ({
  children,
  marketingPreferences,
  myocConfig,
  myocData,
  ...props
}: PropsWithChildren<MyOCAuthProviderProps>) => {
  const value = {
    myocConfig,
    myocData,
    marketingPreferences,
  };

  return (
    <MyOCAuthContext.Provider value={value} {...props}>
      <MyOCUserProvider myocData={myocData}>{children}</MyOCUserProvider>
    </MyOCAuthContext.Provider>
  );
};

export const useMyOCAuth = () => {
  const context = useContext(MyOCAuthContext);
  if (!context) {
    throw new Error('useMyOCAuth can only be used inside of MyOCAuthProvider');
  }

  return context;
};
